import React from 'react';
import PropTypes from 'prop-types';
import { getOne, deleteOne } from 'api/facilityEnviProtectFeeApi';
import Message from 'rc-message';
// import * as _ from 'lodash';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import { Row, Col } from 'reactstrap';
import Confirm from 'components/elements/confirm-element';
import { Link } from 'react-router-dom';
import slug from 'constants/slug';
import { withRouter } from 'react-router-dom';
import { COLOR, STYLE, DATETIME_FORMAT } from 'config';
import moment from 'moment';
import PageLockHOC from 'hoc/pageLock';
import Permissions from 'react-redux-permissions';
// import { Cell, Column, Table, SelectionModes } from '@blueprintjs/table';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

class RowValue extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isRequiredField: PropTypes.bool,
  };

  render() {
    return (
      <div>
        <Row>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Col
              style={this.props.isRequiredField ? STYLE.REQUIREDFIELD : {}}
              xs={2}
            >
              {this.props.label}
            </Col>
            <Col xs={7}>{this.props.value}</Col>
          </div>
        </Row>
        <Clearfix height={8} />
      </div>
    );
  }
}

@PageLockHOC(['facilityEnviProtectFee.view'])
class FacilityEnviProtectFeeView extends React.Component {
  state = {
    _idObject: '',
    isLoaded: false,
    isLoading: false,
    facility: {},
    facilityId: '',
    initialValue: null,
  };

  getInitialValue = (keyPath, defaultValue = '') => {
    let val = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!val) val = '';
    return val;
  };

  getInitialDateValue = (keyPath, defaultValue = '') => {
    let value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) return '';
    return moment(value).format(DATETIME_FORMAT);
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    if (_id) {
      const res = await getOne(_id);
      if (res.success && res.data) {
        this.setState({
          _idObject: res.data._id,
          facility: res.data.facility,
          facilityId: res.data.facility._id,
          isLoading: false,
          isLoaded: true,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.ENVI_PROTECT_FEE.LIST);
    }
  }

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: 'Bạn có muốn xoá ',
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.props.history.push(slug.ENVI_PROTECT_FEE.LIST);
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  async componentWillMount() {
    await this.checkValidate();
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Phí bảo vệ môi trường
        </h4>
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Link to={slug.ENVI_PROTECT_FEE.LIST}>
              <Icon
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                icon={IconNames.CIRCLE_ARROW_LEFT}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
              />
            </Link>

            <Permissions allowed={[`facilityEnviProtectFee.write`]}>
              <React.Fragment>
                <Clearfix width={8} />
                <Link
                  to={slug.ENVI_PROTECT_FEE.EDIT_WITH_ID + this.state._idObject}
                >
                  <Icon
                    style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                    icon={IconNames.MANUALLY_ENTERED_DATA}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.PRIMARY}
                  />
                </Link>
              </React.Fragment>
            </Permissions>

            <Permissions allowed={[`facilityEnviProtectFee.delete`]}>
              <React.Fragment>
                <Clearfix width={8} />
                <Icon
                  style={{ cursor: 'pointer' }}
                  icon={IconNames.BAN_CIRCLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                  onClick={this.handelDelete}
                />
              </React.Fragment>
            </Permissions>
          </div>
        </HeaderContainer>
        <Clearfix height={16} />
        <RowValue
          isRequiredField
          label='Tên cơ sở/dự án'
          value={this.getInitialValue('facility.FacilityNameFull')}
        />
        <RowValue
          isRequiredField
          label='Địa chỉ phát sinh nước thải'
          value={this.getInitialValue('IncurredAddress')}
        />
        <RowValue
          isRequiredField
          label='Điện thoại'
          value={this.getInitialValue('Phone')}
        />
        <RowValue label='Email' value={this.getInitialValue('Email')} />
        <RowValue label='Fax' value={this.getInitialValue('Fax')} />
        <RowValue
          label='Năm tính phí'
          value={this.getInitialValue('YearOfCharge')}
        />
        <RowValue
          isRequiredField
          label='Quý tính phí'
          value={this.getInitialValue('QuaterOfCharge')}
        />
        <RowValue
          isRequiredField
          label='Thuộc đối tượng thu phí'
          value={this.getInitialValue('SubjectOfCharge')}
        />

        <RowValue
          isRequiredField
          label='Thẩm quyền thu phí BVMT'
          value={this.getInitialValue('AuthorityBVMT')}
        />
        <RowValue
          label='Công Nợ'
          value={this.getInitialValue('Indebtedness')}
        />
        <RowValue
          isRequiredField
          label='Tình trạng nộp phí'
          value={this.getInitialValue('PaymentStatus')}
        />
        <RowValue label='Số tiền' value={this.getInitialValue('Payment')} />
        {/* <RowValue
          label="Nhu cầu sử dụng nước trung bình"
          value={this.getInitialValue('AverageWaterDemand') + ' (m3/ngày)'}
        />
        <RowValue
          label="Lưu lượng nước thải phát sinh trung bình"
          value={this.getInitialValue('AverageWasteWater') + ' (m3/ngày)'}
        />
        <RowValue
          label="Lượng nước thải phát sinh theo hồ sơ môi trường"
          value={
            this.getInitialValue('AverageWasteWaterEnviProfile') + ' (m3/ngày)'
          }
        />
        <RowValue
          label="Lượng nước thải phát sinh theo thực tế"
          value={this.getInitialValue('AverageWasteWaterActual') + ' (m3/ngày)'}
        />
        <RowValue
          label="Tổng lượng nước thải phát sinh trong quý"
          value={
            this.getInitialValue('TotalWasteWaterOfQuarter') + ' (m3/ngày)'
          }
        />
        <Row>
          <Col xs={2}>Hàm lượng nước thải</Col>
          <Col xs={4}>
            <Table
              numRows={6}
              defaultColumnWidth={200}
              enableGhostCells={true}
              selectionModes={SelectionModes.NONE}
              enableRowResizing={false}
            >
              <Column
                name="Chỉ tiêu"
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      {this.getInitialValue(
                        `WastewaterContent.${rowIndex}.name`
                      )}
                    </Cell>
                  );
                }}
              />
              <Column
                name="Hàm lượng"
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      {this.getInitialValue(
                        `WastewaterContent.${rowIndex}.value`
                      )}
                    </Cell>
                  );
                }}
              />
            </Table>
          </Col>
        </Row>
       */}
        <Clearfix height={8} />
        <RowValue
          label='Thêm vào'
          value={
            this.getInitialDateValue('AddedOn') +
            ' bởi ' +
            this.getInitialValue('AddedBy')
          }
        />
        <RowValue
          label='Cập nhật lần cuối'
          value={
            this.getInitialDateValue('UpdatedOn') +
            ' bởi ' +
            this.getInitialValue('UpdatedBy')
          }
        />
      </div>
    );
  }
}

export default withRouter(FacilityEnviProtectFeeView);



// WEBPACK FOOTER //
// ./src/containers/FacilityeEnviProtectFeeContainer/FacilityEnviProtectFeeView/index.js